import type { FC, ReactNode } from 'react'

import { CircleCheck } from 'lucide-react'

const ITEMS = [
    'Earnest money receipts',
    'Inspection scheduling',
    'Repair addenda',
    'Appraisal follow-ups',
    'Lender updates',
    'Disclosure packets',
    'Wire verification',
    'Signature reminders',
    'Final walkthroughs',
    'Closing checklists'
]

/* A slow, endless strip of the jobs Closewell handles. Two copies make the loop seamless. */
export const TaskMarquee: FC = (): ReactNode => {
    return (
        <section aria-labelledby='marquee-title' className='pt-16 sm:pt-20'>
            <h2 id='marquee-title' className='reveal px-5 text-center text-[12px] font-medium tracking-[0.18em] text-mist uppercase'>
                Every thread Closewell keeps hold of
            </h2>

            <div className='marquee reveal reveal-d1 relative mt-6 overflow-hidden [mask-image:linear-gradient(90deg,transparent,#000_12%,#000_88%,transparent)]'>
                <div className='marquee-track flex w-max'>
                    {[0, 1].map(copy => (
                        <ul key={copy} aria-hidden={copy === 1 ? 'true' : undefined} className='flex shrink-0 items-center gap-3 pr-3'>
                            {ITEMS.map(item => (
                                <li
                                    key={item}
                                    className='flex items-center gap-2 rounded-full border border-border bg-paper/70 px-4 py-2 text-[14px] whitespace-nowrap text-foreground/80 transition-colors duration-300 hover:border-primary/30 hover:bg-white'
                                >
                                    <CircleCheck className='size-4 text-leaf' />
                                    {item}
                                </li>
                            ))}
                        </ul>
                    ))}
                </div>
            </div>
        </section>
    )
}
